import { render, staticRenderFns } from "./FormTextEditor.vue?vue&type=template&id=f3ad5482&scoped=true&"
import script from "./FormTextEditor.vue?vue&type=script&lang=js&"
export * from "./FormTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./FormTextEditor.vue?vue&type=style&index=0&id=f3ad5482&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ad5482",
  null
  
)

export default component.exports